import { Controller } from 'stimulus'

export default class VideoInfoboxController extends Controller {
  connect() {}

  toggle() {
    this.element.classList.toggle('active')
  }
}
